export default __webpack_public_path__ + "static/media/Logo-FAQGUIDE.e0669f73.svg";